.search-bar {
    position: relative;
    width: 100%;
    height: 35px;
    background-color: white;
}

.bordered {
    composes: search-bar;
    composes: border from '../border/border.module.css';
    box-sizing: border-box;
}

.no-border {
    composes: search-bar;
    border: 1px solid transparent;
}

.search-container {
    position: absolute;
    left: 0;
    height: 100%;
    width: 35px;
    margin-top: -1px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.search-container--small {
    composes: search-container;
    width: 24px;
}

.search-icon {
    font-size: 17px;
    color: var(--icon-secondary);
}

.input {
    /* Inset input to allow border radius */
    margin: 1px;
    width: calc(100% - 2px);
    height: calc(100% - 2px);

    padding: 0 0 0 35px;
    vertical-align: baseline;
    box-sizing: border-box;
    border: none;
    outline: none;
    background: white;
}

.input input {
    background-color: transparent;
    height: 100%;
    padding-left: 0;
}

.input:focus::placeholder {
    color: var(--off-white-dk);
}

.input--small {
    composes: input;
    padding: 0 0 0 24px;
}

.input--no-icon {
    padding: 0 0 0 8px;
}

.clear {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0 16px;
}

.clear--small {
    composes: clear;
    padding: 0 8px;
}
